import { gql } from '@apollo/client';

import { CUSTOM_PACING_LINE_ITEM_ERROR } from '../fragments/customPacingLineItemError';

export const SAVE_CUSTOM_PACING = gql`
  mutation saveCustomPacing($input: SaveCustomPacingPayloadInput!) {
    saveCustomPacing(input: $input) {
      reportId
      success
      message
      summary {
        totalProcessed
        successful
        failed
      }
      errors {
        ...customPacingLineItemError
      }
      lineItemIdList
    }
  }
  ${CUSTOM_PACING_LINE_ITEM_ERROR}
`;
